// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/* export const environment = {
  production: false,
  base_uri: 'http://tools.tecnosystem.test',
  base_uri_api_profit: 'http://api.profit.test',
  base_uri_mikrowisp: 'https://demo.mikrosystem.net/api/v1',
  token_api_mikrowisp: 'Smx2SVdkbUZIdjlCUlkxdFo1cUNMQT09',
  token_api_profit: '1|GxmgI2Gif6HJzORlj6Tc0mMjiNlWFzbRp7W4Bxtx',
}; */

export const environment = {
  production: false,
  base_uri: 'https://qa.tools.tecnosystem.net.ve',
  base_uri_api_profit: 'https://api-global.qa.tecnosystem.net.ve',
  // base_uri_api_profit: 'https://qaapiprofit.sistealarmas.com:9876',
  base_uri_mikrowisp: 'https://demo.mikrosystem.net/api/v1',
  token_api_mikrowisp: 'Smx2SVdkbUZIdjlCUlkxdFo1cUNMQT09',
  token_api_profit: '1|GxmgI2Gif6HJzORlj6Tc0mMjiNlWFzbRp7W4Bxtx',
  uuid_origin_link_panel: 'e8cba9be-c245-4d6d-9976-4a7140037086',
  pusher: {
    instanceId: '62330f94-e2e4-4c6b-a4c2-2e2450aca944',
  },
  version: {
    app_name: 'ngx-admin-tecnosystem-v2',
    version_code: 17,
    version_name: '2.1.1',
    release_date: '2025-01-08',
  },
  channel: 'channel4',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
